<div class="chart-container">
  <canvas #chartCanvas role="img" [attr.aria-label]="ariaLabel"></canvas>
</div>
<div class="legend" aria-hidden="true">
  <div class="legend-item">
    <span class="legend-swatch active"></span>
    <span class="legend-label">{{ LL.coach.billing.recordedHistory.active() }}</span>
  </div>
  <div class="legend-item">
    <span class="legend-swatch asleep"></span>
    <span class="legend-label">{{ LL.coach.billing.recordedHistory.asleep() }}</span>
  </div>
</div>
